<template>
  <v-chip
    v-bind="$attrs"
    v-on="$listeners"
    class="nx-chip">
    <v-avatar v-if="avatar">
      <img :src="avatar" :alt="text">
    </v-avatar>
    <v-avatar v-else>
      <v-icon v-show="icon" class="nx-chip-icon">{{ icon }}</v-icon>
    </v-avatar>
    <span v-html="highlightedText"></span>
  </v-chip>
</template>

<script>
export default {
  name: 'nx-selector-chip',
  props: {
    avatar: String,
    text: String,
    icon: String,
    highlight: Boolean,
    value: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    highlightedText() {
      return this.highlight
        ? this.text.replace(new RegExp(`(${this.highlight})`, 'gi'), '<strong>$1</strong>')
        : this.text;
    },
  },
  methods: {
    onInput() {
      this.$emit('input');
    },
  },
};
</script>
